module.exports = __webpack_public_path__ + "static/img/nos.6934c0d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/nos.png
// module id = kOBK
// module chunks = 1